// extracted by mini-css-extract-plugin
module.exports = {"root":"EmailConfirmationModal_root__1EXVA","content":"EmailConfirmationModal_content__3ptng","title":"EmailConfirmationModal_title__2R4Vk"};